module.exports = __webpack_public_path__ + "img/visa.0d1fbbc4.svg";